var postal = require("common/PubSub");

function AbstractLogger() {
    var self = this;

    var logLevel = AbstractLogger.prototype.INFO;

    this.setLogLevel = function(level) {
        logLevel = level;
    };

    /**
     * @abstract
     */
    this.log = function(level, timestamp, message) {
        // To be overridden by subclasses
    };

    function getTimestamp() {
        var d = new Date();
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var seconds = d.getSeconds();
        var milliseconds = d.getMilliseconds();

        return ((hours < 10) ? "0" + hours : hours)
            + ":" + ((minutes < 10) ? "0" + minutes : minutes)
            + ":" + ((seconds < 10) ? "0" + seconds : seconds)
            + "." + ((milliseconds < 100) ? "0" + ((milliseconds < 10) ? "0" + milliseconds : milliseconds) : milliseconds);
    }

    var consoleLog = console.log.bind(console);
    var consoleInfo = console.info.bind(console);
    var consoleWarn = console.warn.bind(console);
    var consoleDebug = console.debug ? console.debug.bind(console) : function() {};
    var consoleError = console.error.bind(console);

    function log(msg) {
        consoleLog(msg);

        if (logLevel >= AbstractLogger.prototype.INFO) {
            self.log("INFO", getTimestamp(), msg);
        }
    }

    function info(msg) {
        consoleInfo(msg);

        if (logLevel >= AbstractLogger.prototype.INFO) {
            self.log("INFO", getTimestamp(), msg);
        }
    }

    function warn(msg) {
        consoleWarn(msg);

        if (logLevel >= AbstractLogger.prototype.WARNING) {
            self.log("WARN", getTimestamp(), msg);
        }
    }

    function error(msg) {
        consoleError(msg);

        if (logLevel >= AbstractLogger.prototype.ERROR) {
            self.log("ERROR", getTimestamp(), msg);
        }
    }

    function debug(msg) {
        consoleDebug(msg);

        if (logLevel >= AbstractLogger.prototype.DEBUG) {
            self.log("DEBUG", getTimestamp(), msg);
        }
    }

    var configValMap = {
        error : AbstractLogger.prototype.ERROR,
        warning : AbstractLogger.prototype.WARNING,
        info : AbstractLogger.prototype.INFO,
        debug : AbstractLogger.prototype.DEBUG,
        trace : AbstractLogger.prototype.TRACE
    };

    postal.channel("Configuration").subscribe("loglevel", function(val) {
        self.setLogLevel(configValMap[val] || AbstractLogger.prototype.INFO);
    });

    $.extend(console, {log : log,
        info : info,
        warn : warn,
        error : error,
        debug : debug});
}

AbstractLogger.prototype.ERROR = 0;
AbstractLogger.prototype.WARNING = 1;
AbstractLogger.prototype.INFO = 2;
AbstractLogger.prototype.DEBUG = 3;
AbstractLogger.prototype.TRACE = 4;

module.exports = AbstractLogger;